import { VStack } from '@chakra-ui/layout'
import { Box, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AiOutlineUser } from 'react-icons/ai'
import { GrImage as GrImageIcon } from 'react-icons/gr'
import { RiGroupLine } from 'react-icons/ri'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'

const GrImage = styled(GrImageIcon)`
  path {
    stroke: ${props => props.stroke};
  }
`

const ActiveLinkStyles = createGlobalStyle`
  .active-link {
    ${GrImage} {
      path {
        stroke: ${colors.appSlate};
      }
    }

    :not(${GrImage}) {
      svg {
        fill: ${colors.appSlate};
      }
    }
    p {
      color: ${colors.appSlate};
    }
  }
`
const UserSideMenu = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <SideBar heading={t('user_management', 'User management')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        <SideBarItem to="/user-management/users" activeClassName="active-link">
          <Box margin="1rem">
            <AiOutlineUser fontSize="2rem" color={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            {t('users', 'Users')}
          </ChakraText>
        </SideBarItem>
        <SideBarItem
          to="/user-management/user-groups"
          activeClassName="active-link"
        >
          <Box margin="1rem">
            <RiGroupLine fontSize="2rem" color={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            {t('user_groups', 'User groups')}
          </ChakraText>
        </SideBarItem>
      </VStack>
    </SideBar>
  )
}

export default UserSideMenu
